import { createRouter, createWebHistory } from 'vue-router'
// import HomeView from '../views/HomeView.vue'
// import MainView from '../views/MainView.vue'

const routes = [
  {
    path: '/admin',
    name: 'home',
    // component: MainView
    component: () => import('../views/loginView.vue')
  },
  {
    path: '/login',
    name: 'login',
    component: () => import('../views/loginView.vue')
  },


  {
    path: '/help/event',
    name: 'EventView',
    component: () => import('../views/HelpEvent.vue')
  },

  {
    path: '/help',
    name: 'MainView',
    component: () => import('../views/HelpMainView.vue')
  },
  {
    path: '/help/debt',
    name: 'helpDebtView',
    component: () => import('../views/HelpDebtView.vue')
  },
  {
    path: '/help/income',
    name: 'calcIncomeView',
    component: () => import('../views/HelpCalcIncomeView.vue')
  },
  {
    path: '/help/family',
    name: 'calcFamilyView',
    component: () => import('../views/HelpCalcFamilyView.vue')
  },
  {
    path: '/help/result',
    name: 'calcResultView',
    component: () => import('../views/HelpCalcResultView.vue')
  },
  {
    path: '/help/result/additional',
    name: 'calcResultNAView',
    component: () => import('../views/HelpCalcResultNAView.vue')
  },
  {
    path: '/help/submit',
    name: 'helpSubmitView',
    component: () => import('../views/HelpSubmitView.vue')
  },
  {
    path: '/help/complete',
    name: 'helpCompleteView',
    component: () => import('../views/HelpCompleteView.vue')
  },

  {
    path: '/document/:uuid',
    name: 'documentView',
    // params 설정 uuid
    component: () => import('../views/DocumentNewView.vue')

  },
  
   {
    path: '/assistant/corp/purpose',
    name: 'assistantCorpPurposeView',
    component: () => import('../views/AssistantCorpPurpose.vue')
  },


  {
    path: '/corp',
    name: 'corpView',
    component: () => import('../views/CorpView.vue')
  },
  {
    path: '/client/corp',
    name: 'clientCorpView',
    component: () => import('../views/ClientCorpView.vue')
  },
  {
    path: '/client/corp/new',
    name: 'clientCorpSelfView',
    component: () => import('../views/ClientCorpApply.vue')
  },
  {
    path: '/client/stakeholder/list',
    name: 'clientStakeholderListView',
    component: () => import('../views/ClientStakeholderListView.vue')
  },
  {
    path: '/client/stakeholder',
    name: 'clientStakeholderView',
    component: () => import('../views/ClientStakeholderView.vue')
  },
  {
    path: '/client/submit',
    name: 'clientSubmitCompleteView',
    component: () => import('../views/ClientSubmitComplete.vue')
  },
  {
    path: '/viewer',
    name: 'PDFViewer',
    component: () => import('../views/PDFViewer.vue')
  },



  {
    path: '/admin/home',
    name: 'AdminView',
    component: () => import('../views/AdminMain.vue')
  },
  {
    path: '/admin/org',
    name: 'AdminOrg',
    component: () => import('../views/AdminOrg.vue')
  },
  {
    path: '/admin/client',
    name: 'AdminClient',
    component: () => import('../views/AdminClient.vue')
  },
  {
    path: '/admin/case',
    name: 'AdminCaseView',
    component: () => import('../views/AdminCase.vue')
  },
  {
    path: '/admin/user',
    name: 'AdminUserView',
    component: () => import('../views/AdminUser.vue')
  },
  {
    path: '/admin/document',
    name: 'AdminDocumentView',
    component: () => import('../views/AdminDocument.vue')
  },
  {
    path: '/admin/task/project',
    name: 'AdminTaskProjectView',
    component: () => import('../views/AdminTaskProjectView.vue')
  },
  {
    path: '/admin/contents',
    name: 'AdminContentsView',
    component: () => import('../views/AdminContents.vue')
  },



  {
    path: '/admin/assistant/service',
    name: 'AdminServiceView',
    component: () => import('../views/AdminServiceBuilder.vue')
  },

  {
    path: '/admin/assistant/business',
    name: 'AdminBusinessView',
    component: () => import('../views/AdminAssistantBusiness.vue')
  },




  {
    path: '/survey',
    name: 'SurveyView',
    component: () => import('../views/SurveyView.vue')
  },

  {
    path: '/landing/tax',
    name: 'LadingTaxView',
    component: () => import('../views/LandingTax.vue')
  }




  // {
  //   path: '/about',
  //   name: 'about',
  //   // route level code-splitting
  //   // this generates a separate chunk (about.[hash].js) for this route
  //   // which is lazy-loaded when the route is visited.
  //   component: () => import(/* webpackChunkName: "about" */ '../views/AboutView.vue')
  // }
]

const router = createRouter({
  history: createWebHistory(),
  routes
})

export default router
